module.exports = __webpack_public_path__ + "img/munka3.b220ea1f.jpg";